import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";
import React, { useState } from "react";
import Select from "react-select";
import toast from "react-hot-toast";

const index = () => {
  const [agency, Update] = useAgencyInfo();
   const AppService = useAppServices();
  const [googleProcessing, setGoogleProcessing] = useState(false);
  const [review, setReview] = useState(agency?.review || null);
  const handleSaveReview = async (e) => {
    e.preventDefault();
    setGoogleProcessing(true);

    const payload = {
      _id: agency._id,
      review: {
        label: review?.label,
        value: review?.value,
      },
    };
    const { response } = await AppService.agency.update({
      payload,
    });

    if (response?.success) {
          Update(response.data);
          toast.success("Your Review Settings is saved!");
        } else {
          toast.error("Error Review Settings not saved!")
        }
        setGoogleProcessing(false)
  };
  const Review = [
    {
      label: "3 stars",
      value: "3",
    },
    {
      label: "4 stars",
      value: "4",
    },
    {
      label: "5 stars",
      value: "5",
    },
  ];
  return (
    <SoftBox
      mt={2}
      width="98%"
      display="flex"
      gap={2}
      alignItems="center"
      component="form"
      justifyContent="space-between"
      onSubmit={handleSaveReview}
    >
      <div style={{ width: "50%" }}>
        <SoftBox sx={{ zIndex: 10 }}>
          <label>Only Show Reviews With Minimum Star Rating</label>
          <Select
            name="review"
            options={Review}
            value={review}
            onChange={(selected) => setReview(selected)}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
        </SoftBox>
      </div>

      <SoftBox>
        <SoftButton
          sx={{ mt: 2 }}
          disabled={googleProcessing}
          loading={googleProcessing}
          type="submit"
          variant="outlined"
          color="dark"
          size="small"
        >
          Save Review Settings
        </SoftButton>
      </SoftBox>
    </SoftBox>
  );
};

export default index;
